var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.70082C11.5002 7.78384 11.4837 7.86586 11.4517 7.94086C11.4197 8.01586 11.373 8.08194 11.315 8.13424L8.31527 10.8181C8.22581 10.8998 8.1136 10.9445 7.9978 10.9445C7.88199 10.9445 7.76978 10.8998 7.68033 10.8181L4.68061 8.03977C4.57851 7.94546 4.5143 7.80993 4.50212 7.663C4.48993 7.51607 4.53075 7.36977 4.61562 7.2563C4.70048 7.14283 4.82242 7.07147 4.95462 7.05792C5.08682 7.04437 5.21845 7.08975 5.32055 7.18407L8.0003 9.66785L10.68 7.26741C10.7534 7.19947 10.8428 7.1563 10.9376 7.14304C11.0323 7.12977 11.1285 7.14695 11.2148 7.19254C11.301 7.23814 11.3737 7.31024 11.4243 7.40032C11.4748 7.49039 11.5011 7.59468 11.5 7.70082Z",
    fill: "#38D68B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.bf207cf779c280b31385c39faa34e37f.svg";
export { ForwardRef as ReactComponent };